import React, { useEffect } from "react";
import "./tracker-landing-page.css";
import Accordion from "@material-ui/core/Accordion";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import { TutorialAccordianContent } from "./tutorial-accordian-contents";
import { ConsentContent } from "./contents/consent";
import { InstructionContent } from "./instructions/instruction";
import { OrgInfoContent } from "./orgInfo/orgInfo";
import { EnvTempContent } from "./envTemp/envTemp";
import { CarbonEmissionsTemplatePage } from "./carbonEmissionsTemplate/newcarbon";
import * as data from "./data-toload.json";
import { Grid } from "@material-ui/core/";
import { DataProvider } from "../DataContext";
async function getData(url: string): Promise<any> {
  // Default options are marked with *
  const response = await fetch(url, {
    method: "GET", // *GET, POST, PUT, DELETE, etc.
    mode: "cors", // no-cors, *cors, same-origin
    cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
    credentials: "same-origin", // include, *same-origin, omit
    redirect: "follow", // manual, *follow, error
    referrerPolicy: "no-referrer", // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
  });
  if (response.ok) {
    return response.json(); // parses JSON response into native JavaScript objects
  } else {
    const text = (await response.text()).valueOf();
    throw new Error(text);
  }
}
async function putData(url: string, data = {}): Promise<any> {
  // Default options are marked with *
  const response = await fetch(url, {
    method: "PUT", // *GET, POST, PUT, DELETE, etc.
    mode: "cors", // no-cors, *cors, same-origin
    cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
    credentials: "same-origin", // include, *same-origin, omit
    headers: {
      "Content-Type": "application/json",
      // 'Content-Type': 'application/x-www-form-urlencoded',
    },
    redirect: "follow", // manual, *follow, error
    referrerPolicy: "no-referrer", // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
    body: JSON.stringify(data), // body data type must match "Content-Type" header
  });
  if (response.ok) {
    return response.json(); // parses JSON response into native JavaScript objects
  } else {
    const text = (await response.text()).valueOf();
    throw new Error(text);
  }
}
const styles = {
  accordion_template: {
    background: "#C1D300",
    outline: "#c1d300 1px solid",
    color: "white",
    marginTop: "10px",
  },
};
interface IProps {
  userId: number;
}
export const TrackerLandingPage: React.FC<IProps> = (props: IProps) => {
  const [expanded, setExpanded] = React.useState<string | false>(false);

  const handleChange =
    (panel: string) =>
    (event: React.ChangeEvent<unknown>, isExpanded: boolean) => {
      setExpanded(isExpanded ? panel : false);
    };
  function setConsent(consent: boolean) {
    const existingOrgInfo = orgInfo;
    existingOrgInfo.consent = consent;
    setOrgInfo(existingOrgInfo);
    reRender(!render);
    putData(
      "https://greencityapi-new.absolarlab.com/api/OrgInfo/consent?user_id=" +
        props.userId.toString() +
        "&cityCouncilId=0&consent="+consent.toString()
    ).catch(e=>console.log(e.message));
      if(consent){
        setExpanded(false);
      }
  }
  const [existingAnswers, setExistingAnswers] = React.useState<Answer[]>([]);
  const [carbonAnswers, setCarbonAnswers] = React.useState<Answer[]>([]);
  const [template, setTemplate] = React.useState<Template>({
    envTemplate: {},
    envTemplateStyles: {},
  });
  const [orgInfoQuestions, setOrgInfoQuestions] = React.useState<
    OrgInfoQuestion[]
  >([]);
  const [orgInfoAnswers, setOrgInfoAnswers] = React.useState<Answer[]>([]);
  const [render, reRender] = React.useState<boolean>(false);
  const [carbonTemplate, setCarbonTemplate] = React.useState<CarbonTemplate>({
    carbonThemeDto: {},
    carbonStyles: {},
  });
  const [orgInfo, setOrgInfo] = React.useState<OrgInfo>({
    id: 0,
    city_council_id: 0,
    user_id: props.userId,
    company_name: "",
    address: "",
    postcode: "",
    types: [],
    consent: false,
  });
  function submitOrgInfo() {
    setExpanded("panel4");
  }
  useEffect(() => {
    getData(
      "https://greencityapi-new.absolarlab.com/api/Themes/orginfo?cityCouncilId=0"
    )
      .then((data: OrgInfoQuestion[]) => {
        setOrgInfoQuestions(data);
      })
      .catch((e) => {
        alert("error fetching org info questions " + e);
      });
    getData(
      "https://greencityapi-new.absolarlab.com/api/Themes?cityCouncilId=0&user_id=" +
        props.userId.toString()
    )
      .then((data: Template) => {
        setTemplate(data);
      })
      .catch((e) => {
        alert("error fetching template " + e);
      });
    getData(
      "https://greencityapi-new.absolarlab.com/api/Themes/carbon?cityCouncilId=0"
    )
      .then((data: CarbonTemplate) => {
        setCarbonTemplate(data);
      })
      .catch((e) => {
        alert("error fetching template " + e);
      });
    getData(
      "https://greencityapi-new.absolarlab.com/api/Answer?cityCouncilId=0&user_id=" +
        props.userId.toString()
    )
      .then((data: Answer[]) => {
        setExistingAnswers(data);
      })
      .catch((e) => {
        console.log("error fetching answers");
      });
    getData(
      "https://greencityapi-new.absolarlab.com/api/Answer/carbon?cityCouncilId=0&user_id=" +
        props.userId.toString()
    )
      .then((data: Answer[]) => {
        setCarbonAnswers(data);
      })
      .catch((e) => {
        console.log("error fetching answers");
      });
    getData(
      "https://greencityapi-new.absolarlab.com/api/Answer/orginfo?cityCouncilId=0&user_id=" +
        props.userId.toString()
    )
      .then((data: Answer[]) => {
        setOrgInfoAnswers(data);
      })
      .catch((e) => {
        console.log("error fetching answers");
      });
    getData(
      "https://greencityapi-new.absolarlab.com/api/OrgInfo?user_id=" +
        props.userId.toString() +
        "&cityCouncilId=0"
    )
      .then((data: OrgInfo) => {
        setOrgInfo(data);
      })
      .catch((e) => {
        console.log("error fetching orginfo");
      });
  }, []);
  function refreshData() {
    getData(
      "https://greencityapi-new.absolarlab.com/api/Themes?cityCouncilId=0&user_id=" +
        props.userId.toString()
    )
      .then((data: Template) => {
        setTemplate(data);
      })
      .catch((e) => {
        console.log("error fetching template");
      });
    getData(
      "https://greencityapi-new.absolarlab.com/api/Answer?cityCouncilId=0&user_id=" +
        props.userId.toString()
    )
      .then((data: Answer[]) => {
        var newAnswers = existingAnswers.filter((x) => x.id === -1);
        newAnswers = newAnswers.concat(data);
        setExistingAnswers(newAnswers);
      })
      .catch((e) => {
        console.log("error fetching answers");
      });
  }
  function refreshCarbonData() {
    getData(
      "https://greencityapi-new.absolarlab.com/api/Themes/carbon?cityCouncilId=0"
    )
      .then((data: CarbonTemplate) => {
        setCarbonTemplate(data);
      })
      .catch((e) => {
        alert("error fetching template " + e);
      });
    getData(
      "https://greencityapi-new.absolarlab.com/api/Answer/carbon?cityCouncilId=0&user_id=" +
        props.userId.toString()
    )
      .then((data: Answer[]) => {
        var newAnswers = carbonAnswers.filter((x) => x.id === -1);
        newAnswers = newAnswers.concat(data);
        setCarbonAnswers(newAnswers);
      })
      .catch((e) => {
        console.log("error fetching answers");
      });
  }
  return (
    <div>
      <h2 style={{ color: "#44B8A8" }}>Assessment questions</h2>
      {Object.keys(template.envTemplate).length > 0 &&
      Object.keys(carbonTemplate.carbonThemeDto).length > 0 ? (
        <DataProvider
          value={{
            userId: props.userId,
            answers: existingAnswers,
            setAnswers: setExistingAnswers,
            carbonAnswers: carbonAnswers,
            orgInfoAnswers: orgInfoAnswers,
            setOrgInfoAnswers: setOrgInfoAnswers,
            template: template,
            orgInfo: orgInfo,
          }}
        >
          <Grid
            container
            direction="row"
            spacing={1}
            justify="space-between"
            style={{
              marginTop: 10,
              marginBottom: 10,
              width: "100%",
              marginLeft: 0,
            }}
          >
            {Object.keys(template.envTemplate).map((tabName: string) => {
              return (
                <Grid
                  item
                  xs={2}
                  style={{
                    background:
                      template.envTemplateStyles[tabName].themeBackground,
                    textAlign: "center",
                    color: "white",
                    borderBottomStyle: "solid",
                    textTransform: "capitalize",
                  }}
                  key={tabName}
                >
                  <img
                    src={template.envTemplateStyles[tabName].img}
                    style={{ width: "100px" }}
                  />
                  <div style={{ fontSize: 14 }}>{tabName}</div>
                </Grid>
              );
            })}
          </Grid>
          <p style={{ color: "#595959" }}>
            A Performance Tracker has been developed by the{" "}
            <a
              rel="noreferrer"
              target="_blank"
              href="https://energy.soton.ac.uk/"
            >
              Energy and Climate Change Division
            </a>{" "}
            (ECCD) at the University of Southampton, enabling an organisation to
            assess and quantify their present and future development in
            achieving sustainability targets across set themes (criteria).
            Alongside providing a robust assessment it is also an educational
            tool, introducing organisations to sustainability concepts and data
            recording, not only showing opportunity for investment but
            highlighting where current data collection processes may be
            enhanced.
          </p>
          <Accordion
            expanded={expanded === "panel1"}
            onChange={handleChange("panel1")}
          >
            <AccordionSummary
              className="accord_summ2"
              style={styles.accordion_template}
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
              id="panel1a-header"
            >
              <b> Consent</b>
            </AccordionSummary>
            <AccordionDetails className="accord_detail">
              <ConsentContent
                setConsent={setConsent}
                consent={orgInfo.consent}
              />
            </AccordionDetails>
          </Accordion>
          <Accordion
            expanded={expanded === "panel2"}
            onChange={handleChange("panel2")}
            disabled={!orgInfo.consent}
          >
            <AccordionSummary
              style={styles.accordion_template}
              expandIcon={<ExpandMoreIcon />}
              aria-controls="Instructions-content"
              id="Instructions-header"
            >
              <b> Instructions</b>
            </AccordionSummary>
            <AccordionDetails className="accord_detail">
              <InstructionContent />
              {/* <TutorialAccordianContent /> */}
            </AccordionDetails>
          </Accordion>
          <Accordion
            expanded={expanded === "panel3"}
            onChange={handleChange("panel3")}
            disabled={!orgInfo.consent}
          >
            <AccordionSummary
              style={styles.accordion_template}
              expandIcon={<ExpandMoreIcon />}
              aria-controls="Organisation-content"
              id="Organisation-header"
            >
              <b> Organisation information</b>
            </AccordionSummary>
            <AccordionDetails className="accord_detail">
              <OrgInfoContent
                data={orgInfoQuestions}
                submitOrgInfo={submitOrgInfo}
              />
            </AccordionDetails>
          </Accordion>
          <Accordion
            expanded={expanded === "panel4"}
            onChange={handleChange("panel4")}
            disabled={!orgInfo.consent}
          >
            <AccordionSummary
              style={styles.accordion_template}
              expandIcon={<ExpandMoreIcon />}
              aria-controls="Environmental-content"
              id="Environmental-header"
            >
              <b> Sustainability assessment</b>
            </AccordionSummary>
            <AccordionDetails className="accord_detail">
              <EnvTempContent
                data={template.envTemplate}
                styles={template.envTemplateStyles}
                refreshData={refreshData}
              />
            </AccordionDetails>
          </Accordion>
          <Accordion
            expanded={expanded === "panel5"}
            onChange={handleChange("panel5")}
            disabled={!orgInfo.consent}
          >
            <AccordionSummary
              style={styles.accordion_template}
              expandIcon={<ExpandMoreIcon />}
              aria-controls="Carbon-content"
              id="carbon-header"
            >
              <b> Carbon emissions</b>
            </AccordionSummary>
            <AccordionDetails className="accord_detail">
              <CarbonEmissionsTemplatePage
                data={carbonTemplate}
                refreshData={refreshCarbonData}
              />
            </AccordionDetails>
          </Accordion>
        </DataProvider>
      ) : (
        "Loading"
      )}
    </div>
  );
};
